import React from "react";
import Table from "../../components/subcomponents/table";
import TableControl from "../../components/subcomponents/table_control";
import Button from "../../components/subcomponents/controls/button";
import InputField from "../../components/subcomponents/controls/inputfield";
import SelectField from "../../components/subcomponents/controls/selectfield";
import CheckField from "../../components/subcomponents/controls/checkfield";
import { connect } from "react-redux";
import admin from "../../api/admin";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import FormHeader from "../../components/subcomponents/formheader";

class adminList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allow_to_edit: false,
            edit_rec: false,
            new_rec: false,
        };
    }
    componentWillMount() {
        admin.list();
        admin.options();
        this.props.handleSelect();
    }
    selectItem(id) {
        if (this.state.new_rec || this.state.allow_to_edit) {
            notification.error("New/edit rec mode, please cancel before select");
            return null;
        }
        if (id) {
            this.setState({ edit_rec: true });
            this.setState({ allow_to_edit: false });
            this.props.handleSelect(id);
            admin.details();
        } else {
            this.cancel();
        }
    }
    cancel() {
        this.setState({ new_rec: false });
        this.setState({ edit_rec: false });
        this.setState({ allow_to_edit: false });
        this.props.handleSelect();
        admin.list();
    }
    newRec() {
        this.props.handleSelect();
        this.setState({ new_rec: true });
    }
    saveRec() {
        let self = this;
        if (this.state.edit_rec) {
            admin.update((error) => {
                if (!error) {
                    admin.list();
                    self.cancel();
                }
            });
        } else {
            admin.add(function (error) {
                if (!error) {
                    admin.list();
                    self.cancel();
                }
            });
        }
    }
    deleteRec() {
        let self = this;
        admin.del(function (error) {
            if (!error) {
                admin.list();
                self.cancel();
            }
        });
    }
    allowEdit(params) {
        this.setState({ allow_to_edit: params.value });
    }
    showDetails() {
        let details_title = this.state.edit_rec
            ? "Admin details"
            : "Enter new admin";
        let save_btn_label = this.state.edit_rec
            ? "Update"
            : "Add new";
        let confirm_toggle_status = !this.state.new_rec ? "enabled" : "hidden";

        let save_btn =
            this.props.admin_details.login &&
                this.props.admin_details.pass &&
                this.props.admin_details.info &&
                this.props.admin_details.role_id > 0
                ? "enabled"
                : "disabled";
        if (this.state.edit_rec && !this.state.allow_to_edit) save_btn = "hidden";

        let del_btn =
            this.state.edit_rec && this.state.allow_to_edit ? "enabled" : "hidden";

        let inputs_enabled =
            this.state.allow_to_edit || this.state.new_rec ? "enabled" : "disabled";

        //TODO: refactor
        return (
            <SubformDetails
                is_hidden={!this.state.new_rec && !this.state.edit_rec}
                title={details_title}
                className="details width_50"
            >
                <CheckField
                    status={confirm_toggle_status}
                    name="allow_to_edit"
                    label="Enable edit"
                    onChange={this.allowEdit.bind(this)}
                    value={this.state.allow_to_edit}
                />
                <InputField
                    status={inputs_enabled}
                    name="info"
                    label="info (min. 4 chars)"
                    onChange={this.props.fieldChange}
                    value={this.props.admin_details.info}
                    error={this.props.admin_validation["info"]}
                />
                <SelectField
                    status={inputs_enabled}
                    name="role_id"
                    label="Role"
                    options={this.props.admin_options["role_id"]}
                    onChange={this.props.fieldChange}
                    value={this.props.admin_details.role_id}
                    error={this.props.admin_validation["role_id"]}
                />
                <SelectField
                    status={inputs_enabled}
                    name="company_id"
                    label="Company"
                    options={this.props.admin_options["company_id"]}
                    onChange={this.props.fieldChange}
                    value={this.props.admin_details.company_id}
                    error={this.props.admin_validation["company_id"]}
                />
                <InputField
                    status={inputs_enabled}
                    name="login"
                    label="Login (uniq, >4 chars no spaces)"
                    onChange={this.props.fieldChange}
                    value={this.props.admin_details.login}
                    type="text"
                    error={this.props.admin_validation["login"]}
                />
                <InputField
                    status={inputs_enabled}
                    name="pass"
                    label="Password (min. 6 chars)"
                    onChange={this.props.fieldChange}
                    value={this.props.admin_details.pass}
                    type="text"
                    error={this.props.admin_validation["pass"]}
                />
                <div className="toolbar">
                    <Button
                        name="add"
                        label={save_btn_label}
                        onClick={this.saveRec.bind(this)}
                        status={save_btn}
                    />
                    <Button
                        name="delete"
                        label="Delete admin"
                        onClick={this.deleteRec.bind(this)}
                        status={del_btn}
                    />
                    <Button
                        name="cancel"
                        label="Cancel"
                        onClick={this.cancel.bind(this)}
                    />
                </div>
            </SubformDetails>
        );
    }
    render() {
        let new_btn = this.state.edit_rec ? "hidden" : "enabled";
        return (
            <div className="form_wrap admin_list">
                <FormHeader title="ADMIN LIST" />
                <SubformDetails className="master width_50">
                    <TableControl
                        search={this.props.search_string}
                        handleSearch={this.props.handleSearch}
                    />
                    <Table
                        name="admin_list"
                        table_key={"admin_id"}
                        handleSelect={this.selectItem.bind(this)}
                        selected={this.props.admin_selected}
                        headers={{
                            admin_id: { label: "ID", width: "10%" },
                            company_name: { label: "Company", width: "40%" },
                            info: { label: "Info", width: "30%" },
                            role: { label: "Role", width: "20%" },
                        }}
                        data={this.props.admin_list}
                    />
                    <Button
                        name="new"
                        label="New admin"
                        onClick={this.newRec.bind(this)}
                        status={new_btn}
                    />
                </SubformDetails>
                {this.showDetails()}
            </div>
        );
    }
}

/**
 * [Converts plain obj to arr for state]
 * @param obj
 */
function stateArr(obj = {}) {
    let state_arr = [];
    Object.keys(obj).forEach((field) => {
        state_arr.push(obj[field]);
    });
    return state_arr;
}

function mapStateToProps(state) {
    let admin = state.adminR.admin;

    return {
        search_string: admin.search_string,
        admin_list: admin.list,
        admin_selected: admin.selected,

        admin_details: admin.details,
        admin_state: stateArr(admin.detail),

        admin_validation: admin.validation,
        admin_options: admin.options,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch(result) {
            dispatch({
                type: "ADMIN_DESELECTED",
            });
            dispatch({
                type: "ADMIN_UPDATE_SEARCH_STRING",
                value: result.value,
            });
            admin.list();
        },
        handleSelect(id) {
            if (id) {
                dispatch({
                    type: "ADMIN_SELECTED",
                    value: id,
                });
            } else {
                dispatch({
                    type: "ADMIN_DESELECTED",
                });
            }
        },
        cancelSelect() {
            dispatch({
                type: "ADMIN_CANCEL_SELECT",
            });
        },
        fieldChange(result) {
            dispatch({
                type: "ADMIN_UPDATE_FORM",
                field: result.name,
                value: result.value,
            });
        },
    };
}

export default adminList = connect(
    mapStateToProps,
    mapDispatchToProps
)(adminList);
